import { SkipLogicCondition, SkipLogicPredefinedControl, SkipLogicPredefinedControlType } from "./skip-logic.types";

type GetProcessedControlsParams = {
  onConditionMove: (direction: "up" | "down") => void;
  onOpenFoldersSelector: () => void;
  selectedConditionId?: SkipLogicCondition["id"];
  conditions: SkipLogicCondition[];
  onAllConditionsRemove: () => void;
  controls: Array<SkipLogicPredefinedControl>;
};

export type SkipLogicInternalControl = {
  type?: SkipLogicPredefinedControlType;
  handler?: () => void;
  iconSrc?: string;
  description?: string;
  tooltip?: string;
  disabled?: boolean
};

export const getProcessedControls = ({
  onConditionMove,
  onAllConditionsRemove,
  conditions,
  selectedConditionId,
  onOpenFoldersSelector,
  controls,
}: GetProcessedControlsParams): Array<SkipLogicInternalControl> => {
  const predefinedActionsConfig: Record<SkipLogicPredefinedControlType, { config: SkipLogicInternalControl }> = {
    [SkipLogicPredefinedControlType.moveUp]: {
      config: {
        handler: () => onConditionMove("up"),
        iconSrc: "png/arrow_up.png",
        description: "move-up-condition",
        tooltip: "Move field up",
        disabled: false,
      },
    },
    [SkipLogicPredefinedControlType.moveDown]: {
      config: {
        handler: () => onConditionMove("down"),
        iconSrc: "png/arrow_down.png",
        description: "move-down-condition",
        tooltip: "Move field down",
        disabled: false,
      },
    },
    [SkipLogicPredefinedControlType.add]: {
      config: {
        handler: onOpenFoldersSelector,
        iconSrc: "png/add14.png",
        description: "add-condition",
      },
    },
    [SkipLogicPredefinedControlType.removeAll]: {
      config: {
        handler: () => {
          // Only execute if there are conditions to remove
          if (conditions.length > 0) {
            onAllConditionsRemove();
          }
        },
        iconSrc: "png/remove_all.png",
        description: "remove-all-conditions",
        tooltip: "Erase all fields",
        disabled: false,
      },
    },
  };

  return controls.reduce<Array<SkipLogicInternalControl>>((acc, { type, handler, ...otherProps }) => {
    if (type && predefinedActionsConfig[type]) {
      const config = predefinedActionsConfig[type].config;
      const action: SkipLogicInternalControl = {
        ...config,
        ...otherProps,
        // Ensure tooltip is always set from config
        tooltip: config.tooltip || "",
      };

      acc.push(action);
    }

    return acc;
  }, []);
};
